import {
  InquirySession,
  InquirySessionAttributes,
  InquirySessionDeviceType,
  InquirySessionRelationships,
  InquirySessionStatus,
  InquirySessionThreatLevel,
} from 'dashboard/models/inquiry-session';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const startedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewInquirySession(
  attributes?: Partial<InquirySessionAttributes>,
  relationships?: Partial<InquirySessionRelationships>,
  id?: string,
): InquirySession {
  return {
    attributes: {
      'created-at': createdAt,
      'started-at': startedAt,
      status: InquirySessionStatus.Active,
      'ip-address': '192.0.2.1',
      'browser-name': 'Chrome',
      'browser-full-version': '94.0.4606.81',
      'os-name': 'Mac',
      'os-full-version': '10.10.2',
      'device-type': InquirySessionDeviceType.Desktop,
      'country-code': 'US',
      'country-name': 'United States',
      'is-proxy': false,
      'is-tor': false,
      'threat-level': InquirySessionThreatLevel.Low,
      latitude: 38.8976763,
      longitude: -77.0387185,
      ...attributes,
    },
    relationships: {
      'list-matches': { data: [] },
      device: { data: { id: 'dev_123', type: ApiModel.Device } },
      ...relationships,
    },
    id: id || 'iqse_123',
    type: ApiModel.InquirySession,
  };
}
